module.exports = __webpack_public_path__ + "img/2.e267d142.jpg";